export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-foundation-1eda11f1b5cf6ea9b67ad1feea48d414.svg";